module.exports = __webpack_public_path__ + "media/review-badges/rank-10-6387262c.svg";